import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

Swiper.use([Pagination, Navigation]);

const swiperNavNextSelector = '.swiper-button-next';
const swiperNavPrevSelector = '.swiper-button-prev';
const swiperPaginationSelector = '.swiper-pagination';

const swiperConfig = {
    slidesPerView: 'auto',
    spaceBetween: 24
};

document.addEventListener('DOMContentLoaded', () => {
    const $logoSliders = document.querySelectorAll('.widget-logo-slider');

    $logoSliders.forEach(($slider) => {
        let next = $slider.parentNode.querySelector(swiperNavNextSelector);
        let prev = $slider.parentNode.querySelector(swiperNavPrevSelector);
        let pagination = $slider.parentNode.querySelector(swiperPaginationSelector);
        new Swiper($slider, {
            ...swiperConfig,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            pagination: {
                el: pagination,
                clickable: true,
                type: 'fraction'
            }
        });
    });

    const $gallerySliders = document.querySelectorAll('.widget-gallery-slider');

    $gallerySliders.forEach($slider => {
        let next = $slider.parentNode.querySelector(swiperNavNextSelector);
        let prev = $slider.parentNode.querySelector(swiperNavPrevSelector);
        let pagination = $slider.parentNode.querySelector(swiperPaginationSelector);
        new Swiper($slider, {
            ...swiperConfig,
            slidesPerView: 1.2,
            breakpoints: {
                768: {
                    slidesPerView: 1.7
                },
                1024: {
                    slidesPerView: 2.1
                },
                1407: {
                    slidesPerView: 2.5
                },
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            pagination: {
                el: pagination,
                clickable: true,
                type: 'fraction'
            }
        });
    });

    const $quoteSliders = document.querySelectorAll('.widget-quote-slider');

    $quoteSliders.forEach($slider => {
        let next = $slider.parentNode.querySelector(swiperNavNextSelector);
        let prev = $slider.parentNode.querySelector(swiperNavPrevSelector);
        let pagination = $slider.parentNode.querySelector(swiperPaginationSelector);
        new Swiper($slider, {
            ...swiperConfig,
            slidesPerView: 1,
            spaceBetween: 32,
            breakpoints: {
                768: {
                    slidesPerView: 1.3,
                    spaceBetween: 50
                },
                1024: {
                    slidesPerView: 1.4,
                    spaceBetween: 80
                },
                1407: {
                    slidesPerView: 1.5,
                    spaceBetween: 100
                },
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            pagination: {
                el: pagination,
                clickable: true,
                type: 'fraction'
            }
        });
    });

    const $bigQuoteSliders = document.querySelectorAll('.widget-quote-big-slider');

    $bigQuoteSliders.forEach($slider => {
        let next = $slider.parentNode.querySelector(swiperNavNextSelector);
        let prev = $slider.parentNode.querySelector(swiperNavPrevSelector);
        let pagination = $slider.parentNode.querySelector(swiperPaginationSelector);
        new Swiper($slider, {
            ...swiperConfig,
            slidesPerView: 1,
            spaceBetween: 32,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            pagination: {
                el: pagination,
                clickable: true,
                type: 'fraction'
            }
        });
    });

    const $partnerSlider = document.getElementById('partner-slider');

    if ($partnerSlider) {
        new Swiper($partnerSlider, {
            ...swiperConfig,
            slidesPerView: 1,
            spaceBetween: 32,
            navigation: {
                nextEl: swiperNavNextSelector,
                prevEl: swiperNavPrevSelector,
            },
            pagination: {
                el: swiperPaginationSelector,
                clickable: true,
                type: 'fraction'
            }
        });
    }

    const $projectSliders = document.querySelectorAll('.widget-projects-slider');

    $projectSliders.forEach($slider => {
        let next = $slider.parentNode.querySelector(swiperNavNextSelector);
        let prev = $slider.parentNode.querySelector(swiperNavPrevSelector);
        let pagination = $slider.parentNode.querySelector(swiperPaginationSelector);
        new Swiper($slider, {
            ...swiperConfig,
            slidesPerView: 1.2,
            breakpoints: {
                768: {
                    slidesPerView: 2.7
                },
                1024: {
                    slidesPerView: 3.1
                },
                1407: {
                    slidesPerView: 3.5
                },
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            pagination: {
                el: pagination,
                clickable: true,
                type: 'fraction'
            }
        });
    });
});
